import {TemplateType} from "sensoteq-core/enumerations";
import TemplateStore from "./TemplateStore";
import AnalysisGroupSubscription from "models/AnalysisGroupSubscription";

export default class AnalysisGroupStore extends TemplateStore {
  constructor(rootStore) {
    super(rootStore, AnalysisGroupSubscription, TemplateType.ANALYSIS);
  }
}
